<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconSpeakerDisabled_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M4.021 4.045a.625.625 0 0 1 .884 0L20.418 19.56a.625.625 0 0 1-.884.884l-1.276-1.276a9 9 0 0 1-.796.655.75.75 0 1 1-.878-1.216c.146-.106.274-.23.403-.353q.09-.087.184-.173l-1.842-1.842a5.3 5.3 0 0 1-1.16.77.751.751 0 0 1-.638-1.359c.27-.126.511-.29.74-.47l-3.42-3.42v6.907a.833.833 0 0 1-1.5.5l-2.839-3.784-2.737-.547A2.084 2.084 0 0 1 2.1 12.792v-1.584c0-.993.701-1.848 1.675-2.043l2.737-.547.513-.684L4.021 4.93a.625.625 0 0 1 0-.884M19.975 12a8.1 8.1 0 0 1-1.175 4.173l1.093 1.093A9.63 9.63 0 0 0 21.476 12a9.69 9.69 0 0 0-4.013-7.822.75.75 0 1 0-.878 1.216A8.18 8.18 0 0 1 19.975 12m-9.958-7.5c.46 0 .833.373.833.833v2.89l-2.31-2.31.81-1.08a.83.83 0 0 1 .667-.333m5.85 7.5a4.06 4.06 0 0 0-2.336-3.65.75.75 0 1 1 .638-1.358 5.56 5.56 0 0 1 3.2 5.01c0 .787-.175 1.553-.49 2.251l-1.167-1.167c.1-.35.155-.714.155-1.086"
        clip-rule="evenodd"
    />
</svg>
